<template>
  <div class="main-body fill-height">
    <v-layout row wrap class="fill-height">
      <!-- first column -->
      <v-flex xs12 md7 lg7 class="fill-height">
        <div class="first-col-div">
          <img
            src="../assets/auth/logo.png"
            width="40%"
            id="col-1-img"
            alt="logo"
          />
          <h4 id="h4-first-col">Forgot</h4>
          <h2 id="h2-first-col">Your Password?</h2>
          <div v-if="responseStatus != 'success'" class="sign-up-form">
            <p>
              No worries.Enter your email address and <br />
              we'll email you a link to reset it.
            </p>
            <v-form ref="restPasswordForm">
              <v-text-field
                v-model="email"
                outlined
                dense
                placeholder="E-mail Address"
                :rules="[rules.required]"
              ></v-text-field>
              <v-btn
                height="50"
                class="primary mr-4 white--text"
                id="btn-signup"
                :loading="loader"
                @click.prevent="resetPassword"
              >
                <h2 class="text-capitalize">Send</h2>
              </v-btn>
            </v-form>

            <v-layout class="row wrap">
              <v-flex xs12 md12 lg12>
                <p class="mt-3 ml-3">
                  Already have an account?
                  <strong>
                    <router-link to="/" class="link"> Sign In </router-link>
                  </strong>
                </p>
              </v-flex>
            </v-layout>
          </div>

          <div v-if="responseReady" class="responseReady">
            <div v-if="responseStatus == 'success'">
              <div>Password reset successful</div>
              <div class="caption">We have emailed you a reset link</div>
            </div>
          </div>
        </div>
      </v-flex>
      <!-- second column -->
      <v-flex xs0 md5 lg5 class="flex2">
        <!-- <img
          src="../assets/auth/forgotpass.svg"
          width="120%"
          alt="login background"
        /> -->
      </v-flex>
    </v-layout>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loader: false,
      email: "",
      responseReady: false,
      responseStatus: null,
      rules: {
        required: (value) => !!value || "Required",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
    };
  },
  methods: {
    resetPassword() {
      if (this.$refs.restPasswordForm.validate()) {
        this.loader = true;

        axios
          .post(
            "/api/v1/auth/password",
            { email: this.email },
            {
              headers: { Authorization: this.$store.state.token },
            }
          )
          .then(() => {
            this.responseReady = true;
            this.responseStatus = "success";
            this.loader = false;

            this.snackBar.active = true;
            this.snackBar.text = "Password reset successful";
            this.snackBar.color = "success";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          })
          .catch((error) => {
            this.responseReady = true;
            this.responseStatus = "failed";
            this.loader = false;

            this.snackBar.active = true;
            this.snackBar.text =
              error.response.data.message || "Error resetting password";
            this.snackBar.color = "error";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          });
      }
    },
  },
};
</script>

<style scoped>
.main-body {
  height: 100%;
  width: 100%;
  font-family: "Montserrat";
}

#h4-first-col {
  margin-top: -10%;
  margin-left: 4%;
  font-style: bold;
  font-size: 26px;
  color: black;
  font-family: "Montserrat";
}

#h2-first-col {
  color: grey;
  margin-left: 4%;
  font-weight: normal;
  font-family: "Montserrat";
}

#btn-signup {
  width: 100%;
}

.link {
  color: black;
  text-decoration: none;
}
</style>
